/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import type { IConnection } from '@/main/pages/PageAccountInfo/types/pageAccountInfoGeneralTypes';

import { EEdmDeliveryInfoFields } from '../constants';
import type { IAddEdmConnectionForm, IEdmOptionItem } from '../types';
import { EdmOperatorId } from '../types';

export const setEdmConnectionInitialValues = (
  initialOperator?: IEdmOptionItem,
): IAddEdmConnectionForm => ({
  [EEdmDeliveryInfoFields.operator]: initialOperator || {
    value: '',
    label: '',
    isRoaming: false,
  },
  [EEdmDeliveryInfoFields.name]: '',
  [EEdmDeliveryInfoFields.phone]: '',
  [EEdmDeliveryInfoFields.email]: '',
});

export const setEdmChangeOperatorInitialValues = (
  connection: IConnection,
): IAddEdmConnectionForm => {
  const {
    id,
    operatorName,
    responsibleEmail,
    responsibleName,
    responsiblePhone,
    isRoaming,
  } = connection;

  return {
    [EEdmDeliveryInfoFields.operator]: {
      value: EdmOperatorId(id),
      label: operatorName ?? '',
      isRoaming: isRoaming,
    },
    [EEdmDeliveryInfoFields.name]: responsibleName ?? '',
    [EEdmDeliveryInfoFields.phone]: responsiblePhone ?? '',
    [EEdmDeliveryInfoFields.email]: responsibleEmail ?? '',
  };
};
